import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseUrl, getConfig,getUserIdFromToken } from '../../../../../serverUrl';
import { handleUnauthorized } from '../../auth401.ts';
import { User } from './interface.ts';

// Get authorization config
const getConfigData = () => getConfig();

export const userSlice = createApi({
    reducerPath: 'UserApi',
    baseQuery: fetchBaseQuery({ baseUrl }),
    tagTypes: ['User'],
    endpoints: (builder) => ({
        // user details
        getUserDetails: builder.query<User, void>({
                    queryFn: async () => {
                    try {
                        const userID = await getUserIdFromToken();
                        if (!userID) {
                            return { error: { status: 500, data: "User ID not found" } };
                        }    
                        const response = await fetch(`${baseUrl}/users/users-details/${userID}`, getConfigData());
                        if (response.status === 401) {
                            handleUnauthorized();
                            return { error: { status: 401, data: 'Unauthorized' } };
                        }
                        const data = await response.json();
                        return { data };
                    } catch (error) {
                        return { error: { status: 500, data: "Failed to fetch user data" } };
                    }
                },
                providesTags: ['User'],
        }),
    }),
});

// Export hooks for usage in components
export const { useGetUserDetailsQuery } = userSlice;
